import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ng2-tooltip-directive';
import { AnalyticsCoreModule } from '../../analytics-core/analytics-core.module';
import { SharedModule } from '../../shared/shared.module';
import { NavItemComponent } from './components/nav-item/nav-item.component';
import { NavLinkComponent } from './components/nav-link/nav-link.component';
import { NavCardComponent } from './components/nav-card/nav-card.component';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NavigationComponent } from './components/navigation.component';
import { PartnerInfoComponent } from './components/partner-info/partner-info.component';
import { PartnerLogoComponent } from './components/partner-logo/partner-logo.component';
import { PrintableReportItemComponent } from './components/printable-report-item/printable-report-item-r1.component';
import { ProductCsvDownnloadR6Component } from './components/product-csv-downnload-r6/product-csv-downnload-r6.component';
import { PrintableReportComponentR6Component } from './components/printable-report-component-r6/printable-report-component-r6.component';

@NgModule({
	bootstrap: [NavigationComponent],
	declarations: [
		NavigationComponent,
		NavItemComponent,
		PartnerInfoComponent,
		PartnerLogoComponent,
		NavLinkComponent,
		NavCardComponent,
		PrintableReportItemComponent,
		ProductCsvDownnloadR6Component,
		PrintableReportComponentR6Component
	],
	exports: [
		NavigationComponent,
		NavLinkComponent,
		NavItemComponent,
		PartnerInfoComponent,
		PartnerLogoComponent,
		NavCardComponent,
		PrintableReportItemComponent
	],
	imports: [AnalyticsCoreModule, CommonModule, TooltipModule, SharedModule, FormsModule, BrowserModule]
})
export class NavigationModule {}
